import { useToast } from '@hooks';
import { ITaskRawQuery } from '@models/Task.model';
import { patchTask } from '@services/queries/tasks';

import { useMutation, useQueryClient } from 'react-query';

import {
  Container,
  Dialog,
  Label,
  Option,
  OptionBall,
  OptionText,
} from './TaskStatusLabel.styles';

interface ITaskStatusLabel {
  task: ITaskRawQuery;
}

const TaskStatusLabel = ({ task }: ITaskStatusLabel) => {
  const { toast } = useToast();
  const queryClient = useQueryClient();

  const mutation = useMutation(patchTask, {
    onSuccess: async () => {
      toast.success('Task changed successfully');

      queryClient.invalidateQueries(['tasks']);
    },
    onError: () => {
      toast.error('Something got wrong');
    },
  });

  const statusText = () => {
    if (task.status === 'inprogress') return 'In Progress';
    if (task.status === 'done') return 'Done';

    return 'To Do';
  };

  const statusColor = () => {
    if (task.status === 'inprogress') return '#1371FE';
    if (task.status === 'done') return '#249D0E';

    return '#696F8C';
  };

  return (
    <Container onClick={e => e.stopPropagation()}>
      <Dialog
        menuButton={<Label background={statusColor()}>{statusText()}</Label>}
      >
        <Option
          onClick={() => {
            if (task.status !== 'todo') {
              mutation.mutate({
                taskId: task.id,
                status: 'todo',
              });
            }
          }}
        >
          <OptionBall color="#696F8C" />
          <OptionText>To Do</OptionText>
        </Option>
        <Option
          onClick={() => {
            if (task.status !== 'inprogress') {
              mutation.mutate({
                taskId: task.id,
                status: 'inprogress',
              });
            }
          }}
        >
          <OptionBall color="#1371FE" />
          <OptionText>In Progress</OptionText>
        </Option>
        <Option
          onClick={() => {
            if (task.status !== 'done') {
              mutation.mutate({
                taskId: task.id,
                status: 'done',
              });
            }
          }}
        >
          <OptionBall color="#249D0E" />
          <OptionText>Done</OptionText>
        </Option>
      </Dialog>
    </Container>
  );
};

export { TaskStatusLabel };
